import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LocalService, TriggeredEvent, KeyValueSet, InteractionType, KeyValues20, PlanType, ToolPricing, ToolPricingType, BasicPlanMonths, Status, NumericConfig, FocusInputType, PlanPurchaseInvoiceStatus } from '../../../service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';

@Component({
  selector: 'app-plan-purchase-detail-edit',
  templateUrl: './plan-purchase-detail-edit.component.html',
  styleUrl: './plan-purchase-detail-edit.component.scss'
})
export class PlanPurchaseDetailEditComponent {
  PlanType = PlanType; InteractionType = InteractionType; BasicPlanMonths = BasicPlanMonths; PlanPurchaseInvoiceStatus = PlanPurchaseInvoiceStatus;
  @ViewChild('content_plan_purchase_edit')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() editId?: string = undefined;
  @Input() invoiceId: string = '';
  @Input() planTypes: KeyValueSet[] = [];
  @Input() basicPlanMonths: KeyValueSet[] = [];
  @Input() interactionType: InteractionType = InteractionType.None;
  @Input() planInteractionType: InteractionType = InteractionType.None;
  @Input() monthlyPlans: KeyValueSet[] = [];
  @Input() pricing: ToolPricing[] = [];
  @Input() planPurchaseInvoiceStatus: PlanPurchaseInvoiceStatus = PlanPurchaseInvoiceStatus.None;

  canEditByB2b = false;

  elementIds: any; htmlId: string = '';

  item?: KeyValues20 = undefined; selectedBasicPlanMonth: number = BasicPlanMonths._1Year;
  daysInMonth: number = 30; trailDays: number = 7; taxPercetage: number = 0; selectedPlan: PlanType = PlanType.BasicPlan;
  renewalValidity: string[] = []; totalMonths: number = 0;
  numericConfig: NumericConfig = { isDecimalAllowed: true, isStartWithZeroAllowed: true } as NumericConfig;

  numericConfigPhoneNumber: NumericConfig = {} as NumericConfig;

  elligiblePlanTypeToSelect: KeyValueSet[] = []; businessPlanTypes: PlanType[] = [PlanType.BasicPlan, PlanType.CustomReceipt, PlanType.Employee, PlanType.LiveTokens, PlanType.SeatingManagement, PlanType.BatchDetails]; isHasNoLimit: boolean = false;
  elligibleMonthlyPlanTypeToSelect: KeyValueSet[] = []; businessMonthlyPlanTypes: BasicPlanMonths[] = [BasicPlanMonths._1Year];

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, public planPurchaseService: PlanPurchaseService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_amount: 'txt_amount_' + this.htmlId,
      txt_days: 'txt_days_' + this.htmlId,
      ph_num: 'ph_num_' + this.htmlId
    };
  }

  ngOnInit(): void {
    setTimeout(() => { //To avoid NG0100 error
      this.numericConfigPhoneNumber.maxDigits = this.localService.getContactMaxDigitByCountryCode();
    }, 0);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.taxPercetage = this.localService.getLoginAsCountryCode().toLowerCase() == 'ind' ? 18 : 0;
    this.canEditByB2b = this.interactionType == InteractionType.B2B && this.planInteractionType != InteractionType.B2B && this.planPurchaseInvoiceStatus != PlanPurchaseInvoiceStatus.Generated;
    this.renewalValidity = [];
    if (this.interactionType == InteractionType.Bill_PnixSoft) {
      this.elligiblePlanTypeToSelect = this.planTypes.filter(x => ![PlanType.TrailPeriod, PlanType.OneMonthFree].includes(parseInt(x.key)));
      this.elligibleMonthlyPlanTypeToSelect = this.monthlyPlans;
    } else {
      this.elligiblePlanTypeToSelect = this.planTypes.filter(x => this.businessPlanTypes.includes(parseInt(x.key)));
      this.elligibleMonthlyPlanTypeToSelect = this.monthlyPlans.filter(x => this.businessMonthlyPlanTypes.includes(parseInt(x.key)));
    }
    this.elligiblePlanTypeToSelect = this.elligiblePlanTypeToSelect.sort((a, b) => a.value.localeCompare(b.value));
    this.item = undefined;
    if (!this.editId) {
      this.item = {
        key: this.editId,
        v1: '0',
        v2: '0',
        v3: this.selectedPlan.toString(),
        v4: this.taxPercetage.toString(),
        v8: '',
        v9: this.invoiceId,
        v13: '0',
        v14: null,
        v15: this.selectedPlan == PlanType.BasicPlan ? this.getMaxMonthlyPlan() : '0',
        v16: '0',
        v17: '',
        v19: '1'
      } as KeyValues20;
      this.onSetDays();
    } else {
      this.planPurchaseService.getPlanPurchaseInvoiceDetail(this.editId).subscribe(result => {
        this.item = result;
        this.onSetDays();
      });
    }
  }

  onGetGrandTotal(): string {
    const totalAmount = this.item && this.item.v13 ? parseFloat(this.item.v13.toString()) : 0;
    const qty = this.item && this.item.v19 ? parseInt(this.item.v19.toString()) : 1;
    return (totalAmount * qty).toFixed(2);
  }

  onPopupClose() {
    this.onCloseTrigger({ event: TriggeredEvent.Close });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onSave() {
    if (this.item) {
      if (this.interactionType == InteractionType.Bill_PnixSoft && !this.editId) {
        this.item.v16 = this.isHasNoLimit ? '1' : '0';
      }
      this.planPurchaseService.savePlanPurchaseInvoiceDetail(this.item).subscribe(result => {
        switch (result.status) {
          case Status.Success: {
            this.onPopupClose();
          } break;
          case Status.LimitExceeded: {
            this.renewalValidity = result.value.split(';');
          } break;
          case Status.NoLimit: {
            this.localService.showInformation(this.localService.languageContent.plan_purchase.no_limit, true);
          } break;
          default: {
            this.localService.showInformationByStatus(result.status, true);
          } break;
        }
      });
    }
  }

  getMaxMonthlyPlan(): string {
    const maxItem = this.elligibleMonthlyPlanTypeToSelect.reduce((prev, curr) => (parseInt(curr.key) > parseInt(prev.key) ? curr : prev));
    return maxItem.key;
  }

  onReset(isMonthlyPlanChange: boolean = false) {
    const planType: PlanType = parseInt(this.item.v3);

    if (!this.editId) {
      this.item.v14 = null;

      if (planType == PlanType.BasicPlan) {
        if (this.item.v15 == '0') {
          this.item.v15 = this.getMaxMonthlyPlan();
        }
      } else {
        this.item.v15 = '0';
      }

      if (isMonthlyPlanChange && parseInt(this.item.v15) == BasicPlanMonths.Custom) {
        this.item.v2 = BasicPlanMonths.Custom.toString();
      }

      this.item.v16 = '0';
      this.item.v17 = '';

      if (planType == PlanType.Employee) {
        this.localService.onFocusNextInput(this.elementIds.ph_num, FocusInputType.TextBox);
      }
    }
  }

  onSetDays(isMonthlyPlanChange: boolean = false) {
    if (!this.editId) {
      this.renewalValidity = [];
      this.totalMonths = 0;
      if (this.item) {
        this.onReset(isMonthlyPlanChange);

        const planType: PlanType = parseInt(this.item.v3);
        switch (planType) {
          case PlanType.OneMonthFree: {
            this.totalMonths = 1;
            this.item.v2 = this.daysInMonth.toString();
          } break;
          case PlanType.TrailPeriod: {
            this.totalMonths = 1;
            this.item.v2 = this.trailDays.toString();
          } break;
          case PlanType.BasicPlan: {
            this.totalMonths = parseInt(this.item.v15);
            if (parseInt(this.item.v15) != BasicPlanMonths.Custom) {
              this.item.v2 = (parseInt(this.item.v15) * this.daysInMonth).toString();
            }
          } break;
          default: {
            this.totalMonths = 12;
            this.item.v2 = (this.selectedBasicPlanMonth * this.daysInMonth).toString();
          } break;
        }

        this.onSetAmount();
      }
    }
  }

  onSetAmount(isManualAmount?: boolean) {
    if (!isManualAmount) {
      const planType: PlanType = parseInt(this.item.v3);
      switch (planType) {
        case PlanType.BasicPlan: {
          const price = this.pricing.find(x => x.type == ToolPricingType.BasicRentalForBusiness);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            if (parseInt(this.item.v15) != BasicPlanMonths.Custom) {
              this.item.v1 = (parseFloat(this.item.v14.toString()) * parseInt(this.item.v15)).toString();
            } else {
              this.item.v1 = ((this.item.v14 && this.item.v14 != '' ? parseInt(this.item.v14) : 0) * (this.item.v2 && this.item.v2 != '' ? parseInt(this.item.v2) : 0)).toString();
            }
          }
        } break;
        case PlanType.Employee: {
          const price = this.pricing.find(x => x.type == ToolPricingType.EveryUserAfterBasic);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            this.item.v1 = (parseFloat(this.item.v14.toString()) * this.selectedBasicPlanMonth).toString();
          }
        } break;
        case PlanType.LiveTokens: {
          const price = this.pricing.find(x => x.type == ToolPricingType.AdditionalServiceLiveTokens);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            this.item.v1 = (parseFloat(this.item.v14.toString()) * this.selectedBasicPlanMonth).toString();
          }
        } break;
        case PlanType.CustomReceipt: {
          const price = this.pricing.find(x => x.type == ToolPricingType.AdditionalServiceCustomizedBill);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            this.item.v1 = (parseFloat(this.item.v14.toString()) * this.selectedBasicPlanMonth).toString();
          }
        } break;
        case PlanType.SeatingManagement: {
          const price = this.pricing.find(x => x.type == ToolPricingType.AdditionalServiceSeatingManagment);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            this.item.v1 = (parseFloat(this.item.v14.toString()) * this.selectedBasicPlanMonth).toString();
          }
        } break;
        case PlanType.BatchDetails: {
          const price = this.pricing.find(x => x.type == ToolPricingType.AdditionalBatchDetails);
          if (price) {
            if (!this.item.v14 || this.item.v14 == '') {
              if (this.item.v14 == null) {
                this.item.v14 = price.price.toString();
              } else {
                this.item.v14 = '0';
              }
            }
            this.item.v1 = (parseFloat(this.item.v14.toString()) * this.selectedBasicPlanMonth).toString();
          }
        } break;
        default: {
          this.item.v14 = '0';
          this.item.v1 = '0';
        } break;
      }
      if (!this.item.v1) {
        this.item.v14 = '0';
        this.item.v1 = '0';
      }
    } else {
      this.item.v14 = '0';
    }

    if (this.isHasNoLimit) {
      this.item.v2 = '0';
    }
    const tax: number = this.item.v1 != '0' ? ((this.taxPercetage / 100) * parseFloat(this.item.v1)) : 0;
    const totalAmount = parseFloat(this.item.v1) + tax;
    if (this.canEditByB2b || (!this.editId && this.item)) {
      this.item.v13 = totalAmount.toString();
    }
  }
}
